<template>
  <div class="layout-wrapper">
    <el-container class="index-container">
      <el-aside class="layout-contant">
        <Nav></Nav>
      </el-aside>
      <!-- 右边显示区域 -->
      <el-main class="main-wrapper">
        <RightFix></RightFix>
        <App-main></App-main>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import Nav from "./Nav";
import AppMain from "./AppMain";
import RightFix from "./RightFix";
import { mapState } from 'vuex';
export default {
  name: "Layout",
  components: {
    Nav,
    AppMain,
    RightFix
  },
  provide() {
    return {
      previewImgList: this.previewImgList
    }
  },
  computed: {
    ...mapState({
      munuList: state => state.nav.munuList,
    })
  },
  methods: {
    previewImgList(list) {
      return list.map(ele => ele && ele.url) || []
    }
  },
  created() {
    const path = this.$route.path.replace('/', '')
    this.munuList.forEach(element => {
      if (element.route === path) this.$store.commit('setMunuIndex', element.key)
    });
  }
};
</script>
<style lang="less">
.layout-contant {
  width: auto !important;
}
.avatar-img {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-right: 5px;
  &:last-child {
    margin-right: 0;
  }
}
.right-content-wrapper {
  height: 100%;
}
.content-text-toast {
  max-width: 200px;
}
.content-text {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
.layout-wrapper,.index-container  {
  height: 100%;
}
.main-wrapper {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue